import ViewLocations from "./ViewLocations";
import './viewLocations.scss';

export default ViewLocations;